function slideImage() {
    let timeout = setTimeout(() => {
        let el = '.section-app__demo .section-app__image'
        let index = $(`${el}:visible`).index()
        $(`${el}:visible`).hide()
        if ($(el).eq(index + 1).length > 0) {
            $(el).eq(index + 1).show();
        } else {
            $(el).eq(0).show()
        }
        clearTimeout(timeout)
        slideImage();
    }, 5500)
}
$(function () {
    if ($('.section-app__demo').length === 0) {
        return
    }
    slideImage();
})
